// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  label: string;
  children: ReactNode;
}

/** One labelled row of a resolution's preview. */
export function QuarantineResolutionPreviewRow(props: Props) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body2" color="text.secondary">
        {props.label}
      </Typography>
      {typeof props.children === 'string' ? (
        <Typography variant="body2">{props.children}</Typography>
      ) : (
        props.children
      )}
    </Stack>
  );
}
